/* @flow */

export type SortingCriteria = {
    sortFn: Array<(x0: any) => any>;
    ordering: Array<string>;
};

export const sortingCriteriaPersonalLists: SortingCriteria = {
    sortFn: [
        (list) => list?.lifeCycleInformation?.lastEditOn, // we keep it undefined/null as is, do not default to 0
        (list) => (list?.name ?? "").toLowerCase()
    ],
    ordering: ["desc", "asc"]
};

export const sortingCriteriaPersonalListsLastUserInteraction: SortingCriteria = {
    sortFn: [
        (list) => list?.lifeCycleInformation?.lastInteractionTime ?? 0,
        (list) => list?.lifeCycleInformation?.lastEditOn ?? 0,
        (list) => (list?.name ?? "").toLowerCase()
    ],
    ordering: ["desc", "desc", "asc"]
};

export const sortingCriteriaCategories: SortingCriteria = {
    sortFn: [() => 0], // just keep the order provided by the service
    ordering: ["asc"]
};

export const sortingCriteriaBulkDiscountLevels: SortingCriteria = {
    sortFn: [(list) => Number(list?.amountStart ?? "0.00")],
    ordering: ["asc"]
};
